export var ResizeType;
(function (ResizeType) {
    ResizeType["both"] = "both";
    ResizeType["vertical"] = "vertical";
    ResizeType["horizontal"] = "horizontal";
    ResizeType["none"] = "none";
})(ResizeType || (ResizeType = {}));
